export default __webpack_public_path__ + "static/media/arrow-left.c73c1591.svg";